<template>
  <div :class="$vuetify.breakpoint.name === 'lg' ? 'pr-5 pl-5' : 'px-8'">

    <div class="mt-5">

      <Breadcrumbs :title="`Add New Questions`" :items="items"/>
      <Snackbar ref="snackbar"/>

      <div class="mb-8">
        <ValidationObserver ref="observer">
          <v-form>
            <div>
              <v-expansion-panels flat v-model="panel">
                <v-expansion-panel expand v-model="panel" v-for="(item,i) in questions" :key="i" class="mb-3 rounded-lg" style="border: 1px solid #ddd">
                  <v-expansion-panel-header>
                    <span class="font-weight-bold text-h6"> Number {{ i + 1 }} </span>
                    <v-spacer></v-spacer>
                    <div class="text-right">
                      <v-btn
                        icon
                        small
                        @click.stop="confirmDelete(i)">
                        <v-icon color="red">mdi-trash-can-outline</v-icon>
                      </v-btn>
                    </div>
                  </v-expansion-panel-header>
                  <v-divider></v-divider>
                  <v-expansion-panel-content>
                    <div class="mt-7 mb-3">
                      <ValidationProvider :name="item.instruction" rules="required" v-slot="{ errors }">
                        <v-text-field
                          outlined
                          dense
                          v-model="item.instruction"
                          :error-messages="errors"
                          label="Instructions"
                          autocomplete="off"
                          color="#F05326">
                        </v-text-field>
                      </ValidationProvider>
                      <ValidationProvider :name="item.paragraph" rules="required" v-slot="{ errors }">
                        <v-textarea
                          outlined
                          dense
                          rows="3"
                          class="mb-2"
                          @keyup="markdown($event)"
                          persistent-hint
                          hint="Add formatting to your hints using markdown $[your hints]"
                          v-model="item.paragraph"
                          :error-messages="errors"
                          label="Paragraph"
                          autocomplete="off"
                          color="#F05326">
                        </v-textarea>
                      </ValidationProvider>
                      <ValidationProvider :name="item.question" rules="required" v-slot="{ errors }">
                        <v-text-field
                          outlined
                          dense
                          v-model="item.question"
                          :error-messages="errors"
                          label="Question"
                          autocomplete="off"
                          color="#F05326">
                        </v-text-field>
                      </ValidationProvider>
                    </div>

                    <div v-for="(items,index) in item.options" :key="index">
                      <div class="caption text-right">Correct Answer</div>
                      <ValidationProvider :name="item.text" rules="required" v-slot="{ errors }">
                        <v-text-field
                          outlined
                          dense
                          :error-messages="errors"
                          v-model="items.text"
                          :label="`Option ${index + 1}`"
                          autocomplete="off"
                          color="#F05326">
                          <template v-slot:append>
                            <ValidationProvider :name="item.selectedValue" rules="required" v-slot="{ errors }">
                              <v-radio-group class="py-0 pt-0 pa-0" :error-messages="errors" v-model="item.selectedValue">
                                <v-radio color="#F05326" :value="items.text"></v-radio>
                              </v-radio-group>
                            </ValidationProvider>
                          </template>
                        </v-text-field>
                      </ValidationProvider>
                    </div>

                    <div>
                      <v-btn 
                        @click="addOptions(i)"
                        color="#F05326"
                        text 
                        dense 
                        small 
                        elevation="0">
                        <v-icon left>mdi-plus</v-icon>
                        Add Options
                      </v-btn>
                      <v-btn 
                        @click="clearAnswer(i)"
                        color="red"
                        class="float-right"
                        text 
                        dense 
                        small 
                        elevation="0">
                        <v-icon left>mdi-close</v-icon>
                        Clear Answer
                      </v-btn>
                    </div>

                    <div class="mt-5">
                      <ValidationProvider :name="item.correct_explan" rules="required" v-slot="{ errors }">
                        <v-text-field
                          outlined
                          dense
                          v-model="item.correct_explan"
                          :error-messages="errors"
                          label="Correct Answer Explanation"
                          autocomplete="off"
                          color="#F05326">
                        </v-text-field>
                      </ValidationProvider>
                      <ValidationProvider :name="item.incorrect_explan" rules="required" v-slot="{ errors }">
                        <v-text-field
                          outlined
                          dense
                          v-model="item.incorrect_explan"
                          :error-messages="errors"
                          label="Incorrect Answer Explanation"
                          autocomplete="off"
                          color="#F05326">
                        </v-text-field>
                      </ValidationProvider>
                      <ValidationProvider :name="`${item.point}`" rules="required" v-slot="{ errors }">
                        <v-text-field
                          outlined
                          dense
                          type="number"
                          v-model="item.point"
                          :error-messages="errors"
                          label="Point"
                          autocomplete="off"
                          color="#F05326">
                        </v-text-field>
                      </ValidationProvider>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
            <div class="mt-7">
              <v-btn 
                outlined
                dense
                :loading="$store.state.process.run"
                :disabled="$store.state.process.run"
                class="text-capitalize"
                color="#F05326" 
                @click="addQuestion()">
                <v-icon left>mdi-plus</v-icon>
                Add Question
              </v-btn>
              <v-btn
                dense
                depressed
                :loading="$store.state.process.run"
                :disabled="$store.state.process.run"
                class="text-capitalize white--text float-right"
                @click="setData"
                color="#F05326">
                Save
              </v-btn>
              <v-btn
                dense
                depressed
                :loading="$store.state.process.run"
                :disabled="$store.state.process.run"
                class="text-capitalize black--text mr-5 float-right"
                @click="$router.push(`/questions/${$route.params.id_course}/${$route.params.id_topic}/${$route.params.id_activity}/${$route.params.activity_type}`)"
                color="#F5F5F5">
                Cancel
              </v-btn>
            </div>
          </v-form>
        </ValidationObserver>
      </div>
      
    </div>

  </div>
</template>

<script>
import { get, post, put , destroy } from '@/service/Axios'
import Breadcrumbs from '@/components/Breadcrumbs.vue'
import Snackbar from '@/components/Snackbar.vue'
export default {
  data() {
    return {
       /*
       * ANSWER single_choice_hint
       */
      questions: [
        // {
        //   id: 1, 
        //   name: "Nomor 1",
        //   instruction: "",
        //   paragraph: "",
        //   question: "",
        //   selectedValue: "",
        //   correct_explan: "",
        //   incorrect_explan: "",
        //   point: "",
        //   options:[
        //     {
        //       title: "Jawaban A",
        //       text: "",
        //     }
        //   ]
        // }
      ],
      /*
       * ANSWER END 
       */
      panel: 0,
      process: {
        run: false
      },
      items: [
        {
          text: 'Reading',
          disabled: false,
          href: `/questions/${this.$route.params.id_course}/${this.$route.params.id_topic}/${this.$route.params.id_activity}/${this.$route.params.activity_type}`,
        },
        {
          text: 'Add New Questions',
          disabled: true,
          href: '/activity/create',
        }
      ],
    }
  },
  watch: {},
  computed:{},
  components: { Breadcrumbs, Snackbar },
  created(){},
  mounted(){
    if(this.$route.params.id_question){
      this.fetch()
    }else {
      this.questions.push({
        id: "", 
        name: `Nomor ${this.questions.length + 1}`,
        instruction: "",
        paragraph: "",
        question: "",
        selectedValue: "",
        correct_explan: "",
        incorrect_explan: "",
        point: 0,
        options:[
          {
            title: "Jawaban A",
            text: "",
          }
        ]
      });
    }
  },
  methods:{
    async fetch(){
      this.$store.state.process.run = true
      await get(`bank/v1/question/detail/${this.$route.params.id_question}`)
      .then((response) => {
        let res = response.data
        // console.log(res);
        if(res.status == 200){
          this.$store.state.process.run = false
          let question = {
            id: res.data.id,
            instruction : res.data.instruction.text,
            paragraph : res.data.hint.text, 
            question : res.data.question.text,
            selectedValue : res.data.correct_answer[0],
            correct_explan : res.data.explanation.true.text,
            incorrect_explan : res.data.explanation.false.text,
            point : res.data.point,
            options: res.data.options
          }
          // console.log(question)
          this.questions.push(question)
        }else {
          this.$store.state.process.run = false
        }
      })
    },
    /*
     * METHOD QUESTION
     */
    addQuestion() {
      this.questions.push({
        id: "", 
        name: `Nomor ${this.questions.length + 1}`,
        instruction: "",
        paragraph: "",
        question: "",
        selectedValue: "",
        correct_explan: "",
        incorrect_explan: "",
        point: 0,
        options:[
          {
            title: "Jawaban A",
            text: "",
          }
        ]
      });
    },
    addOptions(idx){
      this.questions[idx].options.push(
        {
          title: "Jawaban C",
          text: "",
        },
      )
    },
    confirmDelete(i){
      this.questions.splice(i,1)
    },
    clearAnswer(i){
      this.$refs.observer.reset()
      this.questions[i].selectedValue = ""
    },
    markdown(e){
      // console.log(e);
      if (e.keyCode == 52 || e.keyCode == 219 || e.keyCode == 221) {
        // console.log('markdown looh ');
      }
      if (e.keyCode == 32) {
        // console.log('Spasi looh');
      }
    },
    /*
    * END METHOD QUESTION 
    */
    /**
    * SAVE DATA
    */
    async setData(){
      const isValid = await this.$refs.observer.validate()
      if (this.questions.length < 1) {
        this.$store.state.process.run = false
        this.$refs.snackbar.open("error", `Soal tidak ditemukan`);
      }else{
        if (isValid) {
          this.$store.state.process.run = true
          let data = {}
          this.questions.forEach((item,i) => {
            this.$store.state.process.run = true
            data.options = []
            item.options.forEach((opt,index) => {
              data.options.push({
                media: [],
                text: opt.text
              })
            })
            data.instruction_text = item.instruction;
            data.instruction_media = "";
            data.type = "single_choice_hint";
            data.question_text = item.question;
            data.question_media = "";
            data.point = parseInt(item.point);
            data.correct_answer = [item.selectedValue];
            data.hint = {
              text: item.paragraph,
              media: []
            }
            data.status = "publish"
            data.explanation = {
              true_text: item.correct_explan,
              true_media: "",
              false_text: item.incorrect_explan,
              false_media: ""
            }
            if (item.id !== "") {
              this.save(`update`, `bank/v1/question/${this.$route.params.id_question}`, `api/v1/question/update/${this.$route.params.id_topic}/${this.$route.params.id_activity}/${this.$route.params.id_question}` , data)
            }else {
              this.save(`create`, `bank/v1/question/`, `api/v1/question/add/${this.$route.params.id_topic}/${this.$route.params.id_activity}`, data)
            }
          })
        }else {
          this.$store.state.process.run = false
          this.$refs.snackbar.open("error", `Form Belum Valid`);
        }
      }
    },
    async save(params, url_question, url_activity, data_send){
      this.$store.state.process.run = true
      if(params == `update`){
        await put(url_question,{
          data: data_send
        })
        .then((response) => {
          let res = response.data
          if (res.status == 200) {
            put(url_activity,{
              data: {
                id: res.data.id,
                is_public: false,
                is_paid: true
              }
            })
            .then(response => {
              let res = response.data
              if (res.status == 200) {
                this.$refs.snackbar.open("#4CAF50", `New Question Updated Succesfully`);
                setTimeout(() => {
                  this.$store.state.process.run = false
                  this.$router.push(`/questions/${this.$route.params.id_course}/${this.$route.params.id_topic}/${this.$route.params.id_activity}/${this.$route.params.activity_type}`)
                }, 1000);
              }else{
                this.$store.state.process.run = false
                this.$refs.snackbar.open("error", `New Question Updated Failed`);
              }
            })
          }else{
            this.$store.state.process.run = false
            this.$refs.snackbar.open("error", `New Question Updated Failed`);
          }
        })
      }else {
        await post(url_question,{
          data: data_send
        })
        .then((response) => {
          let res = response.data
          if (res.status == 200) {
            post(url_activity,{
              data: {
                id: res.data.id,
                is_public: false,
                is_paid: true
              }
            })
            .then(response => {
              let res = response.data
              if (res.status == 200) {
                this.$refs.snackbar.open("#4CAF50", `New Question Added Succesfully`);
                setTimeout(() => {
                  this.$store.state.process.run = false
                  this.$router.push(`/questions/${this.$route.params.id_course}/${this.$route.params.id_topic}/${this.$route.params.id_activity}/${this.$route.params.activity_type}`)
                }, 1000);
              }else{
                this.$store.state.process.run = false
                this.$refs.snackbar.open("error", `New Question Added Failed`);
              }
            })
          }else{
            this.$store.state.process.run = false
            this.$refs.snackbar.open("error", `New Question Added Failed`);
          }
        })
      }
    },
    /**
     * SAVE DATA END 
    */
  },
}
</script>

<style>
/* .v-messages__message {
  line-height: 20px !important;
  font-size: 0.900rem !important;
  text-align: end !important;
  word-break: break-word;
  overflow-wrap: break-word;
  word-wrap: break-word;
  -webkit-hyphens: auto;
  -ms-hyphens: auto;
  hyphens: auto;
} */
</style>